import { ISorter, ISorterConfig, ISorterExpression, SorterConfig } from "pbc.types";

export interface IKundenArtSorter extends ISorter {
  id?: ISorterExpression;
  kundenGruppe?: ISorterExpression;
  name?: ISorterExpression;
  beschreibung?: ISorterExpression;
}

export const KundenArtSorterConfig: ISorterConfig = [
  SorterConfig('id', 'Id'),
  SorterConfig('kundenGruppe', 'Kunden Gruppe'),
  SorterConfig('name', 'Name'),
  SorterConfig('beschreibung', 'Beschreibung')
];
